import type { StrapiApiFaq, StrapiFaq } from 'types/strapi/faq'

export function flattenFaq(faq: StrapiApiFaq): StrapiFaq[] {
  const { data: faqItems } = faq

  const items: StrapiFaq[] = faqItems
    ? faqItems.map(faqItem => ({
        question: faqItem.attributes.question,
        answer: faqItem.attributes.answer,
        id: faqItem.id,
      }))
    : []

  return items
}
